import { render, staticRenderFns } from "./List.vue?vue&type=template&id=1378f1ac&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1378f1ac')) {
      api.createRecord('1378f1ac', component.options)
    } else {
      api.reload('1378f1ac', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=1378f1ac&", function () {
      api.rerender('1378f1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/Material/List.vue"
export default component.exports